/**
 * Created by mukund on 7/14/15.
 */
'use strict';

angular.module('mediacloudApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('course', {
                parent: 'site',
                url: '/course/:collectionId',
                params: {
                    destinationFolderId: null,
                    destinationFolderCollectionTree: null,
                    showUnpublished: false
                },
                data: {
                    roles: [],
                    pageTitle: 'course.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/collection/templates/collection.html',
                        controller: 'CollectionController'
                    }
                },

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('course');
                        return $translate.refresh();
                    }]
                }
            });
    });
